import Cookies, { CookieSetOptions } from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';

export const EXPERIMENT_COOKIE = 'cn_experiment_cookie_v2';

export const setExperimentId = (): string => {
  const cookies = new Cookies();
  // Set a 30-day cookie to store a UUID client side
  // Used for Launch Darkly experiments
  const activeCookieValue = cookies.get<string>(EXPERIMENT_COOKIE);

  const expires = new Date();
  expires.setDate(expires.getDate() + 30);

  let cookieAttrs: CookieSetOptions = {
    expires,
    domain: '.chownow.com',
    path: '/',
  };

  // Check if we're embedded in an iframe (any parent domain, not just Yelp)
  let isEmbedded = false;
  try {
    isEmbedded = window.top !== window;
  } catch (_e) {
    // SecurityError can occur in sandboxed iframes with cross-origin restrictions
    // If we can't determine, assume embedded to be safe (apply iframe-safe cookie attrs)
    isEmbedded = true;
  }

  if (isEmbedded) {
    // We need sameSite: none and secure: true when embedded in an iframe
    // since this is a 3rd-party cookie context.
    // See https://stackoverflow.com/questions/2117248/setting-cookie-in-iframe-different-domain
    cookieAttrs = {
      ...cookieAttrs,
      sameSite: 'none',
      secure: true,
    };
  }

  if (!activeCookieValue) {
    // The experiment cookie isn't set. Set it here.
    const cookieValue = `diner-${uuidv4()}`;
    cookies.set(EXPERIMENT_COOKIE, cookieValue, cookieAttrs);
    return cookieValue;
  } else {
    // The experiment cookie already exists. Rewrite it with the same value ensuring the domain is correct
    cookies.set(EXPERIMENT_COOKIE, `${activeCookieValue}`, cookieAttrs);
    return activeCookieValue;
  }
};

export const getExperimentId = (): string | undefined => {
  const cookies = new Cookies();
  return cookies.get<string>(EXPERIMENT_COOKIE);
};
